export default __webpack_public_path__ + "static/media/pq_3.f86c05b0.jpg";